export const schemaRepresentatives = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'carousel', 'keywords', 'filters'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      carousel: {
        title: 'Show as carousel',
        description:
          'Off by default (grid). Enable for horizontal carousel with arrows (e.g. Students).',
        type: 'boolean',
        default: false,
      },
      keywords: {
        title: 'Keywords',
        type: 'array',
        widget: 'array',
        items: {
          vocabulary: { '@id': 'plone.app.vocabularies.Keywords' },
        },
      },
      filters: {
        title: 'Representative categories filters',
        type: 'array',
        widget: 'array',
        items: {
          vocabulary: { '@id': 'unite.representative_categories' },
        },
      },
    },
  };
};

export default schemaRepresentatives;
